<template>
  <div id="popup_view">
    <van-dialog
      :show="visible"
      :showConfirmButton="false"
      :closeOnClickOverlay="true"
      width="55vw"
    >
      <div
        class="popup_content"
        :style="{ 'flex-direction': shrink ? 'column' : 'row' }"
      >
        <van-icon name="cross" class="close" @click="onClose" />
        <div class="thumbnail" :style="{'height': shrink ? '20vh' : '40vh'}">
          <img :src="productInfo.thumbnailLeft" alt="" />
        </div>
        <div class="introduce">
          <div class="options" >
            <div
              class="option"
              v-for="(detail, index) in productInfo.details"
              :key="index"
            >
              <div class="icon">
                <img src="@/assets/product/correct.svg" alt="" />
              </div>
              <span>{{ detail }}</span>
            </div>
          </div>
          <div class="button" @click="onServer">{{$t('product.GET_MORE')}}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script setup lang="ts">
import provide_key from "@/constant/provide_key";
import { defineProps, defineEmits, inject, computed } from "vue";
import { useRouter } from 'vue-router'
import routeHash from '@/constant/router_hash'
import Mitt from "@/utils/mitt";

defineProps(["visible", "productInfo"]);
const emits = defineEmits(["update:visible"]);
const shrink: boolean | undefined = inject(provide_key.SHRINK);

const router = useRouter()

const onClose = () => emits("update:visible", false);

const onServer = () => {
  setTimeout(() => Mitt.emit(routeHash.CONTACT_US), 0)
  onClose()
  router.push({ path: "/company" })
}
</script>

<style scoped lang="less">
#popup_view {
  .popup_content {
    width: 100%;
    height: 65vh;
    background: rgba(0, 0, 0, 0.3);
    position: relative;
    box-shadow: 1px 1px 5px #000;
    align-items: center;
    display: flex;
    padding: 0 1.5rem;
    // justify-content: center;
    overflow: hidden;
    padding: 2rem 1.6rem;

    .close {
      position: absolute;
      top: 2rem;
      right: 2rem;
      font-size: 1.5rem;
      cursor: pointer;
      color: #eee;

      &:hover {
        color: #fff;
      }
    }

    .thumbnail {
      width: 30vw;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .introduce {
      display: flex;
      flex-direction: column;
      -ms-overflow-style: none;
      flex: 1;
      padding: 0.5rem 0;
      height: 100%;
      justify-content: center;

      .options {
        display: flex;
        max-height: calc(100% - 5rem);
        flex-direction: column;
        gap: 1rem;
        font-size: var(--lesser-title);
        overflow-y: auto;
        // justify-content: center;
        
        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-thumb {
          background: #999;
          border-radius: 46px;
        }

        &::-webkit-scrollbar-track {
          margin-top: 10px;
          margin-bottom: 10px;
        }

        .option {
          display: flex;
          flex-shrink: 0;
          gap: 0.4rem;
          color: #3c3c3c;
          align-items: center;

          .icon {
            width: 1.5rem;
            flex-shrink: 0;

            img {
              width: 100%;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }

  .button {
    background: #002fa5;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;
    margin-top: 1.4rem;
    color: #fff;
    cursor: pointer;
    border-radius: 0.5rem;
    font-size: 0.8rem;
    width: 15rem;
    height: 3rem;
    overflow: hidden;

    &:hover {
      background: #073dc4;
    }
  }
}
</style>